import { requestCreateEntitlementPickerExperienceId } from '@atlassian/help-center-common-util/analytics/ufo/ufo';
import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
	UFOExperience,
} from '@atlassian/ufo/ufo-experimental';

export const entitlementPickerLoadExperience = new UFOExperience(
	requestCreateEntitlementPickerExperienceId,
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	},
);
